import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TDashboardStore,
	TMonthlySalesInfoRequest,
	TMonthlySalesInfoResponsePayload,
	TSalesInfoRequest,
	TSalesInfoResponsePayload,
	TTotalTaxesRequest,
	TTotalTaxesResponsePayload,
} from './types';
// ==========================================:
export const initialState: TDashboardStore = {
	totalTaxes: null,
	totalTaxesLoader: false,
	salesInfo: null,
	salesInfoLoader: false,
	monthlySalesInfo: null,
	monthlySalesInfoLoader: false,
};

// ==========================================:
const dashboard = createSlice({
	name: '@@dashboard',
	initialState,
	reducers: {
		getTotalTaxesRequest: (state: TDashboardStore, action: PayloadAction<TTotalTaxesRequest>) => {
			console.log('getTotalTaxesRequest');
			const dashboardState = state;
			dashboardState.totalTaxesLoader = true;
		},
		getTotalTaxesSuccess: (
			state: TDashboardStore,
			action: PayloadAction<TTotalTaxesResponsePayload>,
		) => {
			const { payload } = action;
			const dashboardState = state;
			dashboardState.totalTaxes = payload;
			dashboardState.totalTaxesLoader = false;
		},
		getSalesInfoRequest: (state: TDashboardStore, action: PayloadAction<TSalesInfoRequest>) => {
			const dashboardState = state;
			dashboardState.salesInfoLoader = true;
		},
		getSalesInfoSuccess: (
			state: TDashboardStore,
			action: PayloadAction<TSalesInfoResponsePayload>,
		) => {
			const { payload } = action;
			const dashboardState = state;
			dashboardState.salesInfo = payload;
			dashboardState.salesInfoLoader = false;
		},
		getMonthlySalesInfoRequest: (
			state: TDashboardStore,
			action: PayloadAction<TMonthlySalesInfoRequest>,
		) => {
			const dashboardState = state;
			dashboardState.monthlySalesInfoLoader = true;
		},
		getMonthlySalesInfoSuccess: (
			state: TDashboardStore,
			action: PayloadAction<TMonthlySalesInfoResponsePayload>,
		) => {
			const { payload } = action;
			const dashboardState = state;
			dashboardState.monthlySalesInfo = payload;
			dashboardState.monthlySalesInfoLoader = false;
		},

		assetsInitState: () => initialState,
	},
});

export default dashboard.reducer;
export const {
	getTotalTaxesRequest,
	getTotalTaxesSuccess,
	getSalesInfoRequest,
	getSalesInfoSuccess,
	getMonthlySalesInfoRequest,
	getMonthlySalesInfoSuccess,
	assetsInitState,
} = dashboard.actions;
